import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { AuthProvider } from "@/contexts/AuthContext"
import { Toaster } from "@/components/ui/toaster"
import ProtectedRoute from "@/components/ProtectedRoute"
import AdminLayout from "@/layouts/AdminLayout"
import LoginPage from "@/pages/LoginPage"
import DashboardPage from "@/pages/DashboardPage"
import "./index.css"

import UsersPage from "./pages/UsersPage"
import CategoriesPage from "./pages/CategoriesPage"
import AuthorsPage from "./pages/AuthorsPage"
import ThemesPage from "./pages/ThemesPage"
import CoursesPage from "./pages/CoursesPage"
import VideosPage from "./pages/VideosPage"
import CourseEditPage from "./pages/CourseEditPage"
import BlogsPage from "./pages/BlogsPage"
import BlogEditPage from "./pages/BlogEditPage"
import ReviewsPage from "./pages/ReviewsPage"
import SiteSettingsPage from "./pages/SiteSettingsPage"

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="authors" element={<AuthorsPage />} />
            <Route path="themes" element={<ThemesPage />} />
            <Route path="courses" element={<CoursesPage />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="courses/new" element={<CourseEditPage />} />
            <Route path="courses/:slug/edit" element={<CourseEditPage />} />
            <Route path="blogs" element={<BlogsPage />} />
            <Route path="blogs/new" element={<BlogEditPage />} />
            <Route path="blogs/:slug/edit" element={<BlogEditPage />} />
            <Route path="reviews" element={<ReviewsPage />} />
            <Route path="settings" element={<SiteSettingsPage />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  )
}

export default App
